import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { CardBody, Col, Form, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import { SupportDto } from "../../../../models/supportDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { RootState } from "../../../../store";
import StepperActionButtons from "../../../stepper-action-button/stepperActionButton";
import styles from "./stepOne.module.scss";

const StepOne = (props: any) => {
  toast.configure();
  const location = useLocation<any>();
  let documentRef = React.useRef<any>();
  let langueRef = React.useRef<any>();
  let thematicRef = React.useRef<any>();
  let countryRef = React.useRef<any>();
  const httpClient = useHttpClient(true);
  const path = "/Mediatheque/image/";
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [listOptionsCountry, setListOptionsCountry] = useState([]);
  const [listOptionsDocument, setListOptionsDocument] = useState([]);
  const [isFormValid, setIsFomrValid] = useState(false);
  const [isOnUpdate, setisOnUpdate] = useState(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [, setTitleSupport] = useState("");
  const [pathSupport] = useState(location.pathname.split("/")[2] ? "/Mediatheque/Categories/" + location.pathname.split("/")[2] + "/" : "/Mediatheque/Categories/" + props.path + "/");
  const [listOptionsLanguage] = useState([{ name: "Français" }, { name: "Anglais" }, { name: "Autre" }]);
  const [listOptionsThematic, setListOptionsThematic] = useState([]);
  const [selectedSupport] = useState<any>(null);
  const [selectedSupportImage] = useState<any>(null);
  const [selectedSupportEdit] = useState<any>(null);
  const [, setIsShowDropZone] = useState(true);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      dateSupport: props?.support?.dateSupport ? props.support.dateSupport : "2021",
      title: props.support?.title ? props.support.title : "",
      language: props.support?.language ? props.support.language : "",
      documentTypeId: props.support?.documentTypeId ? props.support.documentTypeId : 0,
      listThematic: props.support?.listThematic ? props.support.listThematic : [],
      listCountry: props.support?.listCountry ? props.support.listCountry : [],
    },
  });

  useEffect(() => {
    if (props.support) {
      setIsFomrValid(true);
      setisOnUpdate(true);
      setValue("dateSupport", props.support?.dateSupport);
      setTitleSupport(props.support?.pathSupport?.slice(props.support?.pathSupport?.lastIndexOf("/") + 1, props.support?.pathSupport?.length));
      if (props.support.urlImage) {
        setIsShowDropZone(false);
      }
      setChecked(props.support.download);
    }

    httpClient.current?.get("/document").then(response => {
      setListOptionsDocument(response.data);
    });
    httpClient.current?.get("/thematic").then(response => {
      setListOptionsThematic(response.data);
    });
    httpClient.current?.get("/country").then(response => {
      setListOptionsCountry(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const onSubmit = (data: SupportDto) => {
    if (!isOnUpdate) {
      let formData = new FormData();
      data.categoryId = props.categoryId;
      data.download = checked;
      if (selectedSupport) {
        if (selectedSupportImage) {
          formData.append("file", selectedSupportImage);
          httpClient.current
            ?.post(`/support/files?path=${path}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              data.pathImage = response.data;
              formData = new FormData();
              formData.append("file", selectedSupport);
              httpClient.current
                ?.post(`/support/files?path=${pathSupport}`, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then(response => {
                  data.pathSupport = response.data;
                  httpClient.current?.post("/support", data).then(response => {
                    toast.success(props.t("message_toastr_add_pdf"), {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 5000,
                    });
                    props.getListSupport();
                    props.closeToggle();
                  });
                });
            });
        } else {
          formData = new FormData();
          formData.append("file", selectedSupport);
          httpClient.current
            ?.post(`/support/files?path=${pathSupport}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              data.pathSupport = response.data;
              httpClient.current?.post("/support", data).then(response => {
                toast.success(props.t("message_toastr_add_pdf"), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
                });
                props.getListSupport();
                props.closeToggle();
              });
            });
        }
      }
    } else {
      hanldeUpdateSupport(data);
    }
  };

  const hanldeUpdateSupport = (support: SupportDto) => {
    support.supportId = props.support.supportId;
    support.pathSupport = props.support.pathSupport;
    support.pathImage = props.support.pathImage;
    support.urlSupport = props.support.urlSupport;
    support.urlImage = props.support.urlImage;
    support.download = checked;
    support.categoryId = props.support.categoryId;
    support.supportESId = props.support.supportESId;
    let formData = new FormData();
    if (selectedSupportImage) {
      handleUpdatingImage(support);
    } else if (selectedSupportEdit) {
      formData = new FormData();
      formData.append("file", selectedSupportEdit);
      httpClient.current
        ?.post(`/support/files?path=${pathSupport}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          support.pathSupport = response.data;
          httpClient.current?.put("/support", support).then(response => {
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        });
    } else {
      httpClient.current?.put("/support", support).then(response => {
        props.closeToggle();
        toast.success(props.t("message_toastr_update"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        props.getListSupport();
      });
    }
  };

  const handleUpdatingImage = (support: SupportDto) => {
    let formData = new FormData();
    formData.append("file", selectedSupportImage);
    httpClient.current
      ?.post(`/support/files?path=${path}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        support.pathImage = response.data;
        if (selectedSupportEdit) {
          let form = new FormData();
          form.append("file", selectedSupportEdit);
          httpClient.current
            ?.post(`/support/files?path=${pathSupport}`, form, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(response => {
              support.pathSupport = response.data;
              httpClient.current?.put("/support", support).then(response => {
                props.getListSupport();
                toast.success(props.t("message_toastr_update"), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
                });
                props.getListSupport();
                props.closeToggle();
              });
            });
        } else {
          httpClient.current?.put("/support", support).then(response => {
            props.getListSupport();
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        }
      });
  };

  const handleIsFormValid = (element: any) => {
    setIsFomrValid(
      getValues().title !== "" &&
        getValues().listCountry.length !== 0 &&
        getValues().listThematic.length !== 0 &&
        getValues().language !== "" &&
        getValues().documentTypeId !== 0 &&
        getValues().dateSupport !== "",
    );
  };

  const handleChangeDocument = (selectedOptions: any) => {
    clearErrors("title");
    clearErrors("documentTypeId");
    if (selectedOptions.length === 1) {
      setValue("documentTypeId", selectedOptions[0].documentTypeId);
      handleIsFormValid(selectedOptions);
    } else {
      setValue("documentTypeId", 0);
      handleIsFormValid(selectedOptions);
    }
  };

  const handleChangeLanguage = (selectedOptions: any) => {
    clearErrors("language");
    if (selectedOptions.length === 1) {
      setValue("language", selectedOptions[0].name);
      handleIsFormValid(selectedOptions);
    } else {
      setValue("language", "");
      handleIsFormValid(selectedOptions);
    }
  };

  const handleChangeThematic = (selectedOptions: any) => {
    clearErrors("listThematic");
    setValue("listThematic", selectedOptions);
    handleIsFormValid(selectedOptions);
  };

  const handleChangeCountry = (selectedOptions: any) => {
    clearErrors("listCountry");
    setValue("listCountry", selectedOptions);
    handleIsFormValid(selectedOptions);
  };

  const validate = () => {
    props.nextStep();
    props.userCallback(getValues());
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className={styles["step-one_form-add-document"] + " card"}>
        <CardBody className="p-t-5 p-b-5">
          <Row>
            <Col lg="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="title" className="form-label">
                  {props.t("pdf_modale.label_title")}*
                </Label>
                <input
                  {...register("title")}
                  required
                  onChange={event => {
                    setValue("title", event.target.value);
                    handleIsFormValid(event.target.value);
                  }}
                  maxLength={100}
                  className={" form-control"}
                  type="text"
                  placeholder={props.t("pdf_modale.label_title")}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="date" className="form-label">
                  {props.t("pdf_modale.label_date")}*
                </Label>{" "}
                <br />
                <Controller
                  control={control}
                  name="dateSupport"
                  rules={{ required: true }}
                  render={({ field: { onChange } }) => (
                    <DatePicker
                      className="form-control"
                      selected={getValues("dateSupport") ? new Date(getValues("dateSupport")) : null}
                      onChange={(e: Date) => {
                        onChange(String(e?.getFullYear()));
                        handleIsFormValid(String(e?.getFullYear()));
                      }}
                      maxDate={new Date()}
                      placeholderText={props.t("pdf_modale.label_date")}
                      dateFormat="yyyy"
                      showYearPicker
                    />
                  )}
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="document" className="form-label">
                  {props.t("pdf_modale.label_document_type")}*
                </Label>
                <Typeahead
                  id="document-typeahead"
                  clearButton
                  defaultSelected={props.support ? [props.support.documentType] : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais".toString() : "titleFrancais".toString()}
                  multiple={false}
                  inputProps={{ required: true }}
                  options={listOptionsDocument}
                  className={errors.title?.message ? styles["form-error"] : ""}
                  placeholder={props.t("pdf_modale.label_document_type")}
                  onChange={handleChangeDocument}
                  onInputChange={e => setError("title", { message: "valeur invalide" })}
                  onBlur={() => documentRef?.current?.blur()}
                  ref={documentRef!}
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="langue" className="form-label">
                  {props.t("pdf_modale.label_language")}*
                </Label>
                <Typeahead
                  id="langue-typeahead"
                  clearButton
                  defaultSelected={props.support ? [props.support.language] : []}
                  labelKey={"name"}
                  multiple={false}
                  className={errors.language?.message ? styles["form-error"] : ""}
                  inputProps={{ required: true }}
                  options={listOptionsLanguage}
                  placeholder={props.t("pdf_modale.label_language")}
                  onChange={handleChangeLanguage}
                  onInputChange={e => setError("language", { message: "valeur invalide" })}
                  onBlur={() => langueRef.current?.blur()}
                  ref={langueRef}
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="thematic" className="form-label">
                  {props.t("pdf_modale.label_thematic")}*
                </Label>
                <Typeahead
                  id="thematic-typeahead"
                  defaultSelected={props.support ? props.support.listThematic : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais"!?.toString()! : "titleFrancais"!?.toString()!}
                  className={errors.listThematic?.message ? styles["form-error"] : ""}
                  multiple={true}
                  options={listOptionsThematic}
                  placeholder={props.t("pdf_modale.label_thematic")}
                  onChange={handleChangeThematic}
                  onInputChange={e => setError("listThematic", { message: "valeur invalide" })}
                  onBlur={() => thematicRef.current?.blur()}
                  ref={thematicRef}
                />
              </FormGroup>
            </Col>
            <Col sm="6" md="6">
              <FormGroup className={styles["add-document-formgroup"]}>
                <Label id="country" className="form-label">
                  {props.t("pdf_modale.label_country")}*
                </Label>
                <Typeahead
                  id="country-typeahead"
                  defaultSelected={props.support ? props.support.listCountry : []}
                  labelKey={selectedLanguage === "en" ? "titleAnglais" : "titleFrancais"}
                  multiple={true}
                  className={errors.listCountry?.message ? styles["form-error"] : ""}
                  options={listOptionsCountry}
                  placeholder={props.t("pdf_modale.label_country")}
                  onChange={handleChangeCountry}
                  onInputChange={e => setError("listCountry", { message: "valeur invalide" })}
                  onBlur={() => countryRef.current?.blur()}
                  ref={countryRef}
                />
              </FormGroup>
            </Col>
          </Row>
          <ModalFooter className="m-t-30 p-b-0 p-t-5">
            <StepperActionButtons close={props.closeToggle} disable={!isFormValid} {...props} nextStep={validate} />
          </ModalFooter>
        </CardBody>
      </Form>
    </>
  );
};

export default translate(StepOne);
